import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

const getPlacementList = async () => {
  const response = await axios.get(`${base_url}placementreport`, config);

  return response.data;
};

//new endpoint
const getPlacementReportList = async () => {
  const response = await axios.get(
    `${base_url}placementreport/placement-overview`,
    config
  );
  return response.data;
};

const getNewPlacementList = async () => {
  const response = await axios.get(
    `${base_url}placementreport/placement`,
    config
  );
  return response.data;
};

const placementService = {
  getPlacementList,
  getPlacementReportList,
  getNewPlacementList,
};

export default placementService;
